import React from 'react';
import { Route, Switch } from 'react-router-dom';

import HistoryForm from '../../../ProductIT/ProductLedger/index';



export default () => (
  <Switch>
    <Route path="/productIT/productLedger" component={HistoryForm} />
    
    
  </Switch>
);
